<template>
  <div class="achievements-carousel-container">
    <carousel-3d
      :perspective="40"
      :width="900"
      :height="450"
      :space="350"
      :autoplay="true"
      :autoplay-timeout="5000"
      :display="3"
      ref="mycarousel"
      @before-slide-change="onBeforeSlideChange"
    >
      <slide :index="index" v-for="(image , index) in images" :key="`image_${index}`">
        <img :data-src="image.link" />
        <p class="mt-5 has-text-white has-text-centered has-text-weight-bold">
          {{image.text}}
        </p>
      </slide>
    </carousel-3d>
    <ul class="carousel-dots" >
      <li v-for="(image , index) in images" :key="`dot_${index}`" :class="[currentIndex === index ? 'is-active' :'' ]"><button @click.prevent="goToSlide(index)"></button></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "AchievementsCarousel",
  data(){
    return{
      currentIndex:0
    }
  },
  props:{
    images:{
      required:false,
      default:[],
      type: Array
    }
  },
  methods: {
    onBeforeSlideChange(index) {
       this.currentIndex = index
    },
    goToSlide(index) {
      this.$refs.mycarousel.goSlide(index);
    },
  },
};
</script>